import React from 'react'
import PropTypes from 'prop-types'

import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

//styles
import style from '@aytm/app/swidget/questions/styles/common/notice.module.scss'

export default class Notice extends PureDataComponent {
  static propTypes = {
    text: PropTypes.string.isRequired,
    showErrors: PropTypes.bool,
    hideVertically: PropTypes.bool
  }

  render() {
    const { text, showErrors = false, hideVertically = false, className, ...restProps } = this.props

    return (
      <div
        {...restProps}
        className={`
        ${style.notice}
        ${showErrors ? style['notice-error'] : ''}
        ${hideVertically ? 'swidget-hide-portrait' : ''}
        ${className ? className : ''}`}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    )
  }
}
